// src/ai/aiApi.ts
import { apiClient, getApiBaseUrl, getAuthHeaders, getStreamFetch } from "@maat/api-base";
var aiApi = {
  generate: async (promptType, payload) => {
    return apiClient.post(`/ai/api/generate/${promptType}`, payload);
  },
  /** Submit the owning user's objective thumbs rating of one generated output. */
  submitRating: async (generationId, payload) => {
    return apiClient.post(`/ai/api/generations/${generationId}/rating`, payload);
  },
  /**
   * Initiates an SSE chat stream via POST.
   * Returns the raw fetch Response so the caller can consume the ReadableStream.
   */
  streamChat: async (message, conversationId, signal, pageContext) => {
    const response = await getStreamFetch()(`${getApiBaseUrl()}/ai/api/chat/stream`, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...getAuthHeaders() },
      credentials: "include",
      body: JSON.stringify({ message, conversationId, pageContext }),
      signal
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: "Stream connection failed" }));
      throw new Error(errorData.message || `HTTP ${response.status}`);
    }
    return response;
  },
  /** One property's day for the front desk; served from the day's cache unless `regenerate`. */
  getShiftBriefing: async (payload) => {
    return apiClient.post("/ai/api/host/shift-briefing", payload);
  },
  /** Record a one-shot 👍/👎 on an assistant message the user owns. */
  rateMessage: async (messageId, payload) => {
    return apiClient.post(`/ai/api/messages/${messageId}/feedback`, payload);
  }
};

export {
  aiApi
};
